module.exports = __webpack_public_path__ + "images/classic-a2ce211a0444e7ef4894c4cd470f36d7.jpg";